// extracted by mini-css-extract-plugin
export default {"page_name":"EditGroup_page_name__vTYSU","panel":"EditGroup_panel__86O15","panel_body":"EditGroup_panel_body__+xUrV","radio":"EditGroup_radio__6jaY5"};